import {useRouter} from "next/router";
import { CategoryType } from '../helper/enums'
export interface CategoryInformationInterface {
  category: CategoryType
  back: boolean
}

export function getCategoryInformation(url: string): CategoryInformationInterface {  
  if(url.includes(CategoryType.Ressort)) {
    return { category: CategoryType.Ressort, back: true }
  }
  else if(url.includes(CategoryType.Article)) {
    return { category: CategoryType.Article, back: true }
  }
  else if(url === "/" || url.startsWith("/?iosapp=1") || url.startsWith("/#")) {
    return { category: CategoryType.Home, back: false }
  }
  else {
    return { category: CategoryType.Unknown, back: true }
  }
  
}

export default function useCategoryInformation() {
  const router = useRouter();

  return [getCategoryInformation(router.asPath)];
}
